import { useWingmanEmbed } from './useWingmanEmbed';
import { WingmanEmbedOverlay } from './WingmanEmbedOverlay';

/* The full-page Wingman dashboard, reached from the top-level "Dashboard" nav item. Served
   same-origin through the gateway's /wingman/* reverse proxy, so this page cannot live at
   /wingman itself (the proxy would swallow the route). The side-pick, auth handshake and
   token-expiry handling all live in useWingmanEmbed, shared with the WingmanPanel slide-out. */

export function WingmanBoard() {
  const { iframeRef, embedStatus, embedUrl, embedAttempt, retryConnection } =
    useWingmanEmbed();

  return (
    <div className='relative h-[calc(100vh-4rem)]'>
      <iframe
        key={embedAttempt}
        ref={iframeRef}
        src={embedUrl}
        title='Wingman'
        className='h-full w-full border-0'
      />
      <WingmanEmbedOverlay embedStatus={embedStatus} onRetry={retryConnection} />
    </div>
  );
}
